export enum Event {
  paywallPreview_onElementHoverClick = 'event/paywallPreview/onElementHoverClick',
}
